export interface IDayHour {
    day: number,
    hour: number
}